import { Component, Input, LOCALE_ID, Inject } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { registerLocaleData } from '@angular/common';
import localeEnIN from '@angular/common/locales/en-IN';
 
// Register the locale data
registerLocaleData(localeEnIN);
 
// Custom date format for en-IN
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
 
@Component({
  selector: 'app-custom-datepicker',
  standalone: true,
  template: `
    <mat-form-field class="mat-date-picker">
      <input placeholder="DD/MM/YYYY" matInput [matDatepicker]="picker" [formControl]="_control" [max]="maxDate" (keydown)="preventNonNumeric($event)">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  `,
  imports: [
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-IN' }
  ],
})
export class CustomDatepickerComponent {
  @Input() reactiveFormControl: AbstractControl | null = null;  
 
  public _control: FormControl = new FormControl(); // default dummy
  @Input() setDate!: Date;
  maxDate: any = new Date();  
  previousKey: string = '';
 
  constructor(
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string
  ) {
    this._adapter.setLocale('en-IN');
  }
 
  ngOnChanges() {
   
  }  
 
  ngAfterViewInit() {
    if (this.reactiveFormControl instanceof FormControl) {
      this._control = this.reactiveFormControl as FormControl;
  
      // Convert "dd/MM/yyyy" string to Date if necessary
      const val = this._control.value;
      if (typeof val === 'string' && val.includes('/')) {
        const parsedDate = this.parseDateString(val);
        if (parsedDate instanceof Date && !isNaN(parsedDate.getTime())) {
          this._control.setValue(parsedDate, { emitEvent: false }); // Don't trigger form changes
        }
      }
    } else {
      console.warn('Provided control is not a FormControl:', this.reactiveFormControl);
    }
  }

  private parseDateString(dateStr: string): Date | null {
    const parts = dateStr.split('/');
    if (parts.length === 3) {
      const day = +parts[0];
      const month = +parts[1] - 1; // Month is 0-based in JS Date
      const year = +parts[2];
      const parsedDate = new Date(year, month, day);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    }
    return null;
  }  
  
 
  preventNonNumeric(event: KeyboardEvent): void {
    // console.log(event.key);
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control', '/', 'Shift', 'Home', 'End'];
    if (this.previousKey === 'Control') {
      allowedKeys.push('V');
      allowedKeys.push('v');
      allowedKeys.push('X');
      allowedKeys.push('x');
      allowedKeys.push('C');
      allowedKeys.push('c');
    }
    if (!/[0-9]/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
    this.previousKey = event.key;
  }
}
 